module.exports = __webpack_public_path__ + "img/KSC03899.0d33ebe0.jpg";